import { useState, useEffect, useCallback } from "react";
import {
  IPerformanceMetricInput,
  UserInterface,
  ICountry,
} from "../../../interface";
import CountryFilter from "../../../components/CountryFilter";
import { Category } from "../../../interface/Enums/category.enum";
import { PerfType } from "../../../interface/Enums/peftype.enum";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountries } from "../../../APIs";
import { fetchAPI } from "../../../utils/FetchApi";
import { FetchMethods } from "../../../interface/Enums/methods.enum";
import { setError } from "../../../store/reducers/errorReducer";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";
import { BsPerson } from "react-icons/bs";
import AdminContainer from "../../../admin-components/AdminContainer";
import { Modal, BtnCreate } from "../../../components/StyledComponents";
const ManagePerformanceOutputMetrics = () => {
  const dispatch:any = useDispatch();
  const data: UserInterface = useSelector((data: any) => {
    return data.auth.user;
  });

  const [listOfCountries, setlistOfCountries] = useState<ICountry[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [performanceMetrics, setPerformanceMetrics] = useState<
    IPerformanceMetricInput[]
  >([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [formData, setFormData] = useState<IPerformanceMetricInput>({
    name: "",
    explanation: "",
    category: Category.OUTPUT,
    type: PerfType.STANDARD,
    country: "",
    importance: 1,
    createdAt: new Date(),
    updatedAt: new Date(),
    creator: (data?.name && data?.surname) ? data.name + " " + data.surname : "",
    _id: ""
  });

  const resetForm = () => {
    setFormData({
      name: "",
      explanation: "",
      category: Category.OUTPUT,
      type: PerfType.STANDARD,
      country: "",
      importance: 1,
      createdAt: new Date(),
      updatedAt: new Date(),
      creator: (data?.name && data?.surname) ? data.name + " " + data.surname : "",
      _id: ""
    });
  };

  const openCreateModal = () => {
    const currentCreator = (data?.name && data?.surname) ? data.name + " " + data.surname : "";
    setFormData({
      name: "",
      explanation: "",
      category: Category.OUTPUT,
      type: PerfType.STANDARD,
      country: "",
      importance: 1,
      createdAt: new Date(),
      updatedAt: new Date(),
      creator: currentCreator,
      _id: ""
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const openEditModal = (metric: IPerformanceMetricInput) => {
    setFormData(metric);
    setIsEditMode(true);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsEditMode(false);
    resetForm();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'importance' ? parseInt(value) : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validation
    if(formData.name.length===0 || formData.country.length===0 || formData.country === "---" || formData.creator.length===0 || formData.explanation.length===0 || formData.importance<1 || formData.importance>100){
      dispatch(setError("Please fill in all the fields correctly - name, country, creator, explanation must not be empty and importance must have a value from 1 to 100"));
      return;
    }

    try {
      let result: IPerformanceMetricInput[];
      
      if (isEditMode) {
        // For update, send the full formData including _id
        result = await fetchAPI("/admincmds/update-performance-output-metric", FetchMethods.PATCH, formData);
      } else {
        // For create, only send the necessary fields (exclude _id, createdAt, updatedAt)
        const createData = {
          name: formData.name,
          explanation: formData.explanation,
          category: formData.category,
          type: formData.type,
          country: formData.country,
          importance: formData.importance,
          creator: formData.creator
        };
        result = await fetchAPI("/admincmds/create-performance-output-metric", FetchMethods.POST, createData);
      }
      
      setPerformanceMetrics(result);
      closeModal();
    } catch (error: any) {
      dispatch(setError(error.message?.toString() || error.toString()));
    }
  };

  const deletePerformanceMetric = async (index: number) => {
    //confirm delete
    if(!window.confirm("Are you sure you want to delete this performance metric?"))return;

    try {
      const listOfAllInputs: IPerformanceMetricInput[] = await fetchAPI(
        `/admincmds/delete-performance-output-metric/${performanceMetrics[index]._id}`,
        FetchMethods.GET
      );
      console.log(listOfAllInputs)
      if (listOfAllInputs.hasOwnProperty("error")) {
        //@ts-ignore
        throw new Error(listOfAllInputs.message?.toString());
      }

      setPerformanceMetrics(listOfAllInputs);
    } catch (error: any) {
      dispatch(setError(error.toString()));
    }
  };
  
 const pickCountry = useCallback((country: string): void => {
    setSelectedCountry(country);
  }, []);

  /**
   * Use Effects
   */
  useEffect(() => {
    (async () => {
      const ctries: ICountry[] = await getAllCountries();
      ctries.sort((a, b) => (a.name > b.name ? 1 : -1));
      setlistOfCountries(ctries);
    })();
  }, []);

  //Load all inputs based on the country
  useEffect(() => {
    if(selectedCountry.length>0){
      (async () => {
        try {
          const getAllInputs: IPerformanceMetricInput[] = await fetchAPI(
            `/admincmds/get-all-performance-output-metrics/${selectedCountry}`,
            FetchMethods.GET
          );
          if (getAllInputs.hasOwnProperty("error")) {
            throw new Error(JSON.stringify(getAllInputs));
          }
          setPerformanceMetrics(getAllInputs);
        } catch (error: any) {
          dispatch(JSON.stringify(error.message));
        }
      })();
    }
    
    //do nothing yet
  }, [selectedCountry, dispatch]);
  
  return (
    <AdminContainer>
          <div className="row justify-content-between align-items-center">
        <div className="col-lg-8 m-2">
        <CountryFilter returnedCountry={pickCountry} />
        </div>
        <div className="col-lg-2 m-2 p-1">
    
              <BtnCreate onClick={openCreateModal}>
                Create Performance Output Metric
              </BtnCreate>
        </div>
      </div>
<hr className="hr" />
      <div className="row justify-content-md-center">
        {performanceMetrics.map((c: IPerformanceMetricInput, i: number) => (
          <div className="card col-lg-3 col-md-4 cal-sm-2 m-2" key={i}>
            <div className="row flex-row-reverse">
              <div className="m-2">
                <Dropdown>
                  <Dropdown.Toggle size="sm" variant="info">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="#/action-1"
                      onClick={() => {
                        openEditModal(performanceMetrics[i]);
                      }}
                    >
                      Update
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#/action-2"
                      onClick={() => {
                        deletePerformanceMetric(i);
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Badge
                  bg={c.category === "input" ? "secondary" : "success"}
                  className="mr-2"
                >
                  {c.category}
                </Badge>
                <Badge
                  bg={c.type === "standard" ? "info" : "danger"}
                  className="mr-2"
                >
                  {c.type}
                </Badge>
                <Badge bg="warning" className="mr-2">
                  {c.importance}%
                </Badge>
              </div>
            </div>
            <div className="card-body">
              <Accordion>
                <Accordion.Item eventKey={i.toString()}>
                  <Accordion.Header>
                    <BsPerson />
                    {"   "}
                    <small className="m-2" style={{ fontWeight: "bold" }}>
                      {c.name}
                    </small>
                  </Accordion.Header>
                  <Accordion.Body key={i}>
                    <strong>Explanation:</strong>
                    <p>{c.explanation}</p>
                    <br />
                    <Badge bg="secondary">By: {c.creator}</Badge>
                    <br />
                    <Badge bg="secondary">Country scope: {c.country}</Badge>
                    <br />
                    <Badge bg="secondary">Importance: {c.importance}%</Badge>
                    <br />
                    <Badge bg="secondary">Category: {c.category}</Badge>
                    <br />
                    <Badge bg="secondary">Type: {c.type}</Badge>
                    <br />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        ))}
      </div>
      
      {/* Modal for Create/Update */}
      <Modal
        isOpen={showModal}
        onClose={closeModal}
        title={isEditMode ? "Update Performance Output Metric" : "Create Performance Output Metric"}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="name" className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="explanation" className="form-label">Description</label>
            <textarea
              className="form-control"
              id="explanation"
              name="explanation"
              value={formData.explanation}
              onChange={handleInputChange}
              rows={3}
              required
            />
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="country" className="form-label">Country</label>
            <select
              className="form-control"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              required
            >
              <option value="">Choose country</option>
              {listOfCountries.map((country: ICountry, index: number) => (
                <option key={index} value={country.name}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="importance" className="form-label">Importance Weight</label>
             <input
                        value={formData.importance}
                        max={100}
                        min={0}
                        defaultValue={1}
                        className="form-control"
                        type="number"
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            importance: parseInt(target.value),
                          });
                        }}
                      />
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="creator" className="form-label">Creator Information</label>
            <input
              type="text"
              className="form-control"
              id="creator"
              name="creator"
              value={formData.creator}
              disabled
            />
          </div>
          
          <div className="d-flex justify-content-end gap-2 mt-4">
            <button type="button" className="dai-btn dai-btn-secondary" onClick={closeModal}>
              Cancel
            </button>
            <button type="submit" className="dai-btn dai-btn-success">
              {isEditMode ? "Update" : "Create"} Performance Output Metric
            </button>
          </div>
        </form>
      </Modal>
    </AdminContainer>
  );
};

export default ManagePerformanceOutputMetrics;